import { gql } from '@apollo/client';

export const BackupMemberFragment = gql`
  fragment BackupMemberFragment on BackupMember {
    id
    role
    user {
      id
      name
      email
      phone
      role
    }
    policy {
      remove
      update
    }
  }
`;
